module.exports = __webpack_public_path__ + "static/media/Hotel-Suggati.a1c6a2de.png";